import { projectRequest } from 'api';

/**
 * POST /announcement/confirm/{id} - Record announcement confirmation with timestamp
 * 
 * @param announcementId - ID of the announcement to confirm
 * @returns Promise that resolves when confirmation is recorded
 */
export const confirmAnnouncement = async (announcementId: number): Promise<void> => {
  try {
    await projectRequest(false, 'v2').post(`/announcement/confirm/${announcementId}`);
  } catch (error) {
    console.error(`Failed to confirm announcement ${announcementId}:`, error);
    throw error;
  }
};